<template>
	<div class="main-recruit">
		<navigations :path="path"></navigations>

		<img class="recruit-img" src="../assets/back-1.png" alt="" />

		<div class="container-recruit">
			<div class="recruit-hint phone-hidden">人才招聘</div>

			<div class="recruit-line phone-hidden"></div>

			<div class="recruit-big phone-hidden">人才理念</div>

			<div class="recruit-image phone-hidden">
				<img class="recruit-image-title" src="../assets/idea.png" alt="" />
			</div>

			<div class="recruit-line phone-hidden"></div>

			<div class="recruit-big phone-hidden">薪酬福利</div>

			<div class="recruit-center">
				<img class="recruit-map" src="../assets/tree.png" alt="" />
			</div>

			<div class="recruit-line phone-hidden"></div>

			<div class="recruit-big">公司寄语</div>

			<div class="recruit-green">
				<span>更多的机会 丰厚的回报</span>
				<span>广阔的发展空间,欢迎大家加入时购圈</span>
			</div>

			<div class="recruit-image">
				<img class="recruit-image-title" src="../assets/sendword.png" alt="" />
			</div>

			<div class="recruit-hint">招聘岗位</div>

			<div class="recruit-line"></div>

			<div class="recruit-frame">
				<div class="recruit-frame-title">
					<span class="recruit-frame-explain">大量招募【城市合伙人】</span>
				</div>
				<div class="recruit-frame-table">
					<span>您只需要：</span>
					<span>1.下载时购圈app申请成为城市合伙人；</span>
					<span>2.参加免费培训了解时购圈的平台优势以及推广模式；</span>
					<span>3.微信转发（发朋友圈、发群）或其他平台分享时购圈app和小程序；</span>
					<span>4.邀请商家入驻，或推荐给更多朋友下载使用时购圈；</span>
					<span>5.分享推广平台，即有机会收获随机推广红包奖励；</span>
					<span>6.提现，收钱。</span>
				</div>
				<div class="recruit-frame-table">
					<span>适合人群：</span>
					<span>1.学历不限，经验不限，有意向拓展副业的人员均可申请成为城市合伙人；</span>
					<span>2.在校大学生、宝妈、想做副业、创业起步人群尤其适合；</span>
					<span>3.正直诚信，有较强的执行能力、抗压能力，具有强烈的成就动机；</span>
					<span>4.勇于挑战自我、对互联网有想法的，可晋升主管带领团队。</span>
				</div>
				<div class="recruit-frame-table recruit-frame-blue">
					<span>
						准备好迎接一场创业机遇了吗？邀请好友一同解锁平台福利，收获丰厚推广惊喜奖励！ 公司致力于打造实体经济互联网商业圈，未来发展前景广阔！
						现大量招募城市合伙人，时间自由，操作方便。公司提供免费培训，陪你开启副业增收之路。
					</span>
					<span>这是一个不错的副业、兼职和拓展人脉的机会！ 成为时购圈 APP 城市合伙人的你，将拥有无限的机会和潜力！赶快加入我们，与时购圈 APP 一起携手前行吧！</span>
				</div>
			</div>

			<div class="recruit-qrcode">
				<div class="recruit-qrcode-box">
					<div class="recruit-qrcode-box-code">
						<img src="../assets/applet.jpg" alt="" />
					</div>
					<div class="recruit-qrcode-box-content">
						<span class="recruit-qrcode-box-title">体验小程序</span>
						<span class="recruit-qrcode-box-text">即扫即用，方便快捷</span>
						<span class="recruit-qrcode-box-text">当天选货，可自提可配送</span>
						<span class="recruit-qrcode-box-text">海量红包，推广有奖</span>
					</div>
				</div>
				<div class="recruit-qrcode-box">
					<div class="recruit-qrcode-box-code">
						<img src="../assets/logo-3.png" alt="" />
					</div>
					<div class="recruit-qrcode-box-content">
						<span class="recruit-qrcode-box-title">下载APP</span>
						<span class="recruit-qrcode-box-text">海量红包，尽在时购圈手机端</span>
						<span class="recruit-qrcode-box-text">一键社交，高级拼玩</span>
						<span class="recruit-qrcode-box-text">推广拓新享福利</span>
						<span class="recruit-qrcode-box-text">
							随机惊喜红包最高可达
							<span class="recruit-qrcode-box-blue">999元</span>
						</span>
					</div>
				</div>
			</div>

			<div class="recruit-frame recruit-up phone-hidden">
				<div class="recruit-frame-title">
					<span class="recruit-frame-explain">话务员/呼叫中心客服</span>
				</div>
				<div class="recruit-frame-table">
					<span>岗位职责:</span>
					<span>1、接听公司400热线，回复用户问题并提供专业解答；</span>
					<span>2、讲解APP功能并有效指导用户下载注册；</span>
					<span>3、及时做好来电登记和用户信息统计表；</span>
					<span>4、分析用户需求，配合线下做好用户的业务服务；</span>
					<span>5、定期完成电话回访工作，维护良好的客户关系。</span>
				</div>
				<div class="recruit-frame-table">
					<span>任职要求:</span>
					<span>1、全日制大专及以上学历，电脑操作熟练；</span>
					<span>2、普通话标准，口齿清晰，表达、沟通能力强；</span>
					<span>3、有较强的客户服务意识，能够积极主动解决问题；</span>
					<span>4、有呼叫中心或客服工作经验优先。</span>
				</div>
				<div class="recruit-frame-table">
					<span>工作时间:</span>
					<span>1、朝九晚六，周日单休；</span>
					<span>2、后期根据工作需要可灵活排班。</span>
				</div>
				<div class="recruit-frame-table">
					<span>薪资详情:</span>
					<span>公司将提供充足的培训及广阔的发展空间；</span>
					<span>综合薪资：4000-15000元/月</span>
				</div>
			</div>

			<div class="recruit-center">
				<img class="recruit-service" src="../assets/entry.png" alt="" />
			</div>
		</div>
		<tabbar></tabbar>
	</div>
</template>

<script>
export default {
	name: 'recruit',
	props: {
		msg: String
	},
	data() {
		return {
			path: '/recruit'
		};
	},
	methods: {}
};
</script>

<style>
html,
body {
	width: 100%;
	height: 100%;
	margin: 0;
	overflow: auto;
}

.main-recruit {
	width: 100%;
	height: 100%;
	padding-top: 100px;
	box-sizing: border-box;
}

.container-recruit {
	width: 100%;
	min-height: 100%;
	padding: 5% 15% 0 15%;
	box-sizing: border-box;
}

.recruit-center {
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: flex-start;
	justify-content: center;
	align-items: flex-start;
	min-height: 100px;
}

.recruit-line {
	width: 100%;
	height: 1px;
	background-color: rgba(0, 0, 0, 0.5);
	margin-top: 100px;
	margin-bottom: 100px;
}

.recruit-map {
	width: 80%;
}

.recruit-hint {
	width: 100%;
	font-weight: 900;
	letter-spacing: 5px;
	font-size: 48px;
	color: #383838;
}

.recruit-img {
	width: 100%;
}

.recruit-image {
	width: 100%;
	height: 100px;
	box-sizing: border-box;
}

.recruit-image-title {
	width: 30%;
}

.recruit-service {
	width: 50%;
	margin-bottom: 100px;
	margin-top: 100px;
}

.recruit-big {
	font-size: 60px;
	color: #808080;
	font-weight: 900;
	margin-bottom: 50px;
}

.recruit-green {
	font-size: 42px;
	color: #00baad;
	margin-bottom: 50px;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	letter-spacing: 2px;
}

.recruit-frame {
	width: 100%;
	min-height: 1000px;
	box-sizing: border-box;
	background-color: #fafafa;
	border-radius: 30px;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-content: flex-start;
	align-items: flex-start;
	justify-content: flex-start;
	padding: 80px;
}

.recruit-frame-table {
	width: 100%;
	line-height: 60px;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-content: flex-start;
	align-items: flex-start;
	justify-content: flex-start;
	margin-top: 50px;
}

.recruit-frame-table span {
	font-size: 24px;
	color: #808080;
}

.recruit-frame-explain {
	font-size: 32px;
	color: #808080;
}

.recruit-frame-blue span {
	color: #00baad;
}

.recruit-qrcode {
	width: 100%;
	min-height: 200px;
	box-sizing: border-box;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: center;
	align-items: center;
	margin-top: 100px;
}

.recruit-qrcode-box {
	width: 40%;
	height: 200px;
	box-sizing: border-box;
	padding: 30px;
	margin: 0 15px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: center;
	align-items: center;
	background-color: #fff;
	border-radius: 30px;
	box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1);
}

.recruit-qrcode-box-code {
	width: 35%;
}

.recruit-qrcode-box-code img {
	width: 100%;
}

.recruit-qrcode-box-content {
	width: 65%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-content: flex-start;
	align-items: flex-start;
	justify-content: center;
	padding-left: 15px;
	box-sizing: border-box;
	line-height: 30px;
}

.recruit-qrcode-box-title {
	font-size: 36px;
	color: #00baad;
	margin-bottom: 10px;
}

.recruit-qrcode-box-text {
	font-size: 21px;
	color: #757575;
}

.recruit-qrcode-box-blue {
	color: #00baad;
}

.recruit-up {
	margin-top: 100px;
}

@media screen and (max-width: 768px) {
	.phone-hidden {
		display: none;
	}

	.main-recruit {
		padding-top: 70px;
	}

	.container-recruit {
		padding: 15% 5% 0 5%;
	}

	.recruit-center {
		height: auto;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		margin-top: 0px;
	}

	.recruit-map {
		width: 100%;
	}

	.recruit-line {
		margin-top: 50px;
		margin-bottom: 50px;
	}

	.recruit-image-title {
		width: 60%;
	}

	.recruit-service {
		margin-bottom: 0px;
		margin-top: 0px;
		width: 100%;
	}

	.recruit-frame {
		padding: 10px;
		min-height: 850px;
		margin-bottom: 30px;
	}

	.recruit-qrcode {
		display: none;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		margin-top: 50px;
	}

	.recruit-qrcode-box {
		width: 100%;
		padding: 15px;
		margin: 15px 15px;
	}

	.recruit-qrcode-box-title {
		font-size: 18px;
		margin-bottom: 10px;
	}

	.recruit-qrcode-box-text {
		font-size: 14px;
		text-align: left;
	}

	.recruit-big {
		font-size: 24px;
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.recruit-green {
		font-size: 12px;
		margin-bottom: 15px;
	}

	.recruit-green span {
		margin-bottom: 15px;
	}

	.recruit-image {
		height: 30px;
		margin-bottom: 30px;
	}

	.recruit-hint {
		font-size: 24px;
	}

	.recruit-frame-explain {
		font-size: 16px;
	}

	.recruit-frame-table span {
		font-size: 12px;
	}

	.recruit-frame-table {
		margin-top: 30px;
		line-height: 30px;
		text-align: left;
	}
}
</style>
